import cn from 'classnames';

import {
  CANCELLED,
  COMPLETED,
  DECLINED,
  DECLINED_ALT,
  DECLINED_CANCELLED,
  DELIVERY_MISTAKE,
  PROCESSING,
  RETURNED,
  RETURNING,
  RETURNING_ALT,
  SHIPPED,
  SUBMITTED
} from 'constants/orderStatuses';

import {
  cancelled,
  processing,
  returned,
  shipped,
  statusLabel,
  submitted
} from 'styles/components/account/orderTableLayout.scss';

export function makeFormErrorMessage(errorDetails) {
  let errorMsg = 'We\'re very sorry, there was an issue processing your request.'; // generic error
  let errorMsgAdditional = '';
  if (errorDetails?.extraInformation?.length) {
    const { extraInformation } = errorDetails;
    errorMsg = 'We\'re very sorry, please fix the following issues:';
    extraInformation.map(info => {
      const { fieldName } = info;
      switch (fieldName) {
        case 'fullName':
        case 'name.fullName':
          errorMsgAdditional += '<li>Name</li>';
          break;
        case 'addCreditCardNumber':
          errorMsgAdditional += '<li>Card number</li>';
          break;
        case 'expirationMonth':
          errorMsgAdditional += '<li>Expiration month</li>';
          break;
        case 'expirationDate':
          errorMsgAdditional += '<li>Expiration date</li>';
          break;
        case 'mailingAddress.addressLine1':
          errorMsgAdditional += '<li>Address Line 1</li>';
          break;
        case 'mailingAddress.addressLine2':
          errorMsgAdditional += '<li>Address Line 2</li>';
          break;
        case 'mailingAddress.city':
          errorMsgAdditional += '<li>City</li>';
          break;
        case 'mailingAddress.stateOrRegion':
          errorMsgAdditional += '<li>State/Region</li>';
          break;
        case 'mailingAddress.postalCode':
          errorMsgAdditional += '<li>Zip/Postal Code</li>';
          break;
        case 'phone.voice.primary.number':
          errorMsgAdditional += '<li>Phone Number</li>';
          break;
        default:
          errorMsgAdditional = '';
      }
    });
  }
  return (
    <>
      <p><strong>Oh No!</strong> {errorMsg}</p>
      <ul dangerouslySetInnerHTML={{ __html: errorMsgAdditional }} />
    </>
  );
}

export function getItemStatusClassName(status) {
  return cn(statusLabel, {
    [submitted]: status === SUBMITTED || status === COMPLETED,
    [processing]: status === PROCESSING,
    [shipped]: status === SHIPPED,
    [returned]: status === RETURNED || status === RETURNING || status === RETURNING_ALT,
    [cancelled]: status === CANCELLED || status === DECLINED_CANCELLED || status === DECLINED || status === DECLINED_ALT || status === DELIVERY_MISTAKE
  });
}
